import { useEventBus } from '@vueuse/core';

const bus = useEventBus<string>('bus');

export default bus;
